import { Box, Button, FileInput, Image, LoadingOverlay, Paper, SimpleGrid, Space, Switch, Text, TextInput, Title } from '@mantine/core'
import React, { memo, useEffect, useRef, useState } from 'react'
import useFetch from '../../../../Customhooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from '../../../../Constants/constant';
import { notifications } from '@mantine/notifications';
import classes from '../ManageCustomer.module.css'
import LocationAutocomplete from '../../../../CustomComponent/LocationAutocomplete';

const AddCustomers = () => {
    const navigate = useNavigate();
    const [value, setValue] = useState<any>();
    const [customername, setCustomername] = useState<string>('');
    const [location, setLocation] = useState<any>();
    const [pathId, setPathId] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [imageUrl, setImageUrl] = useState<string>('');
    const [preview, setPreview] = useState<string | null>(null);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [checked, setChecked] = useState(false);
    const token = localStorage.getItem("token")
    const { id } = useParams();
    const updatedUrl = baseUrl.replace("/api/", "");
    const method = id ? 'PUT' : 'POST'
    const url = id ? `${baseUrl}admin/customers/update/${id}` : `${baseUrl}admin/customers/add`
    const fetchConfig = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    };

    const formData = new FormData();
    if (value) formData.append("icon_name", value);
    formData.append("customer_name", customername)
    formData.append("location", location)
    formData.append("email_address", email)
    formData.append("place_id", pathId)

    const {
        data: getData,
        loading: detailLoading,
        error: getError,
        fetchData: postmaterial,
    } = useFetch({
        method: method,
        headers: {
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
        body: formData
    });
    const {
        data: getfieldData,
        loading: getfieldLoading,
        error: getfielderror,
        fetchData: getfield,
    } = useFetch(fetchConfig);
    useEffect(() => {
        if (id) {
            getfield(`${baseUrl}admin/customers/${id}`)
        }
    }, [])
    useEffect(() => {
        if (getfieldData?.data?.rows?.length) {
            setCustomername(getfieldData.data.rows[0].customer_name);
            setEmail(getfieldData.data.rows[0].email_address);
            setLocation(getfieldData.data.rows[0].location);
            setImageUrl(getfieldData.data.rows[0].icon_name);
            setPathId(getfieldData.data.rows[0].place_id);
        }
    }, [getfieldData]);
    useEffect(() => {
        if (value) {
            const objectUrl = URL.createObjectURL(value);
            setPreview(objectUrl);
            return () => URL.revokeObjectURL(objectUrl); // Cleanup
        }
    }, [value]);

    const handleChange = (field: string, value: any | File | null) => {
        if (field === "customer_name") {
            setCustomername(value as string);
        } else if (field === "Email_id") {
            setEmail(value as string);
        } else if (field === "location") {
            setLocation(value as string);
        } else if (field === "category_icon") {
            setValue(value as File); // Ensure value is stored as a File object
        }
        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    // Handle location change with place_id from LocationAutocomplete
    const handleLocationChange = (value: string | null, placeId?: string) => {
        setLocation(value || '');
        setPathId(placeId || '');
        setErrors((prev: any) => ({ ...prev, location: undefined }));
    };

    const validateFields = () => {
        let newErrors: Record<string, string> = {};

        if (!customername.trim()) {
            newErrors.customer_name = "Customer Name is Required";
        }
        if (!location) {
            newErrors.location = "Location is Required";
        }
        if (!email) {
            newErrors.Email_id = "Email Id is Required";
        }
        if (!id) {
            if (!value) {
                newErrors.category_icon = "Customer Icon is Required";
            } else if (!(value instanceof File)) {
                newErrors.category_icon = "Invalid file format";
            }
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false;
        }
        return true;
    };

    const handlesave = async () => {
        if (!validateFields()) return;
        await postmaterial(url);
    };
    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Customer data saved successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (getData?.errors || getError) {
            showNotification('error', getData?.message || getError?.message);
            return;
        }

        if (getData && !getData?.errors) {
            navigate('/manage-customers');
            showNotification('success', getData?.message || getError?.message);
        }
    }, [getData, getError, navigate, classes]);


    return (
        <>
            <LoadingOverlay
                visible={getfieldLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            <Paper shadow="xs" p="xs" radius="md">
                <Box ml={5}>
                    <Title order={4}>Add Customer</Title>
                    <Space h="lg" />
                    <Box>
                        <Switch
                            checked={checked}
                            onChange={(e) => {
                                const val = e.currentTarget.checked;
                                setChecked(val);
                            }}
                            style={{float:'right'}}
                            label={checked ? "Lat Lng Input On" : "Lat Lng Input Off"}
                            mb={4}
                        />
                        <Text>Customer details</Text>
                    </Box>
                    <Space h="xs" />
                    <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }}>
                        <TextInput
                            variant='filled'
                            label="Customer name"
                            withAsterisk
                            value={customername}
                            onChange={(e) => handleChange("customer_name", e.target.value)}
                            placeholder="Enter Customer name"
                            radius={6}
                            error={errors.customer_name}

                        />

                        <TextInput
                            variant='filled'
                            withAsterisk
                            label="Email Address"
                            type='email'
                            value={email}
                            onChange={(e) => handleChange("Email_id", e.target.value)}
                            placeholder="Enter Email id"
                            radius={6}
                            error={errors.Email_id}
                        />
                        <LocationAutocomplete
                            label="Location"
                            placeholder="Enter your location"
                            withAsterisk
                            value={location}
                            onChange={handleLocationChange}
                            error={errors.location}
                            latLngMode={checked}
                        />
                        <FileInput
                            label="Upload icon"
                            withAsterisk={id ? false : true}
                            variant="filled"
                            placeholder="Upload icon"
                            value={value}
                            onChange={(file) => handleChange("category_icon", file)}
                            radius={6}
                            error={errors.category_icon}
                        />

                        {(preview || id) ? (
                            <Box className={classes.verticalslogo}>
                                <Image
                                    fit="contain"
                                    src={preview || (id ? `${updatedUrl}${imageUrl}` : null)}
                                    alt="icon"
                                />
                            </Box>
                        ) : null}
                    </SimpleGrid>
                    <Space h="xl" />
                    <SimpleGrid cols={6}>
                        <Button
                            variant="default"
                            radius={6}
                            onClick={() => navigate('/manage-customers')}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="gradient"
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            radius={6}
                            onClick={handlesave}
                            loading={detailLoading}
                            disabled={detailLoading}
                        >
                            {id ? 'Update' : 'Save'}
                        </Button></SimpleGrid>
                </Box>
            </Paper>
        </>
    )
}

export default memo(AddCustomers)